/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgAlertSuccess24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='#00AD82'
        fillRule='evenodd'
        d='M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm18.537 0c0-4.712-3.825-8.537-8.537-8.537-4.712 0-8.537 3.825-8.537 8.537 0 4.712 3.825 8.537 8.537 8.537 4.712 0 8.537-3.825 8.537-8.537zm-10.394 3.31a.095.095 0 01-.069-.03L6.85 12.017a.098.098 0 00-.138 0l-.45.446-.45.447a.098.098 0 000 .137l4.253 4.305a.098.098 0 00.138 0l3.922-3.898 3.924-3.9a.098.098 0 000-.139l-.445-.45-.446-.45a.098.098 0 00-.138 0l-6.808 6.766a.096.096 0 01-.069.028z'
      />
    </svg>
  );
}

export default SvgAlertSuccess24;
